import Image from 'next/image';

import { SFCampaignPromotionItemViewModel } from '@api/index';
import { daysBetween } from '@utils/dateUtil';
import { optimizeImage } from '@utils/imageOptimization';
import LazyImage from '@components/Carousel/LazyImage';

import {
  BottomRightImageWrapper,
  Card,
  CardContent,
  CardImageInnerWrapper,
  CardImageWrapper,
  CardTitle,
  CardWrapper,
  ExpirationDateWrapper,
} from './styled';

export type ICampainCard = SFCampaignPromotionItemViewModel & {
  useLazyLoad?: boolean;
};

const CampainCard = ({
  title,
  image = { url: '/static/images/placeholder-image.webp' },
  href,
  lastDate,
  ticketImage,
  useLazyLoad = false,
}: ICampainCard) => {
  const ImageComponent = useLazyLoad ? LazyImage : Image;
  const imageProps = useLazyLoad
    ? { rootMargin: '200px' }
    : { loading: 'lazy' as const };

  return (
    <CardWrapper prefetch={false} href={href || ''}>
      <Card>
        <CardImageWrapper>
          <CardImageInnerWrapper>
            <ImageComponent
              className='campainCard__image'
              src={optimizeImage(
                image?.url || '/static/images/placeholder-image.webp',
                '500',
                '500'
              )}
              alt={
                image?.alt ||
                title ||
                'Kampanya görseli - Detaylar için tıklayın'
              }
              fill
              sizes='(max-width: 1200px) 100vw, 450px'
              loading='lazy'
              data-src={optimizeImage(
                image?.url || '/static/images/placeholder-image.webp',
                '500',
                '500'
              )}
              {...imageProps}
            />
          </CardImageInnerWrapper>
        </CardImageWrapper>
        <CardContent>
          <CardTitle className='campaignCard__title' title={title}>
            {title}
          </CardTitle>
        </CardContent>
      </Card>
      {lastDate && daysBetween(new Date(), new Date(lastDate)) >= 0 && (
        <ExpirationDateWrapper>
          <span>
            SON
            {` ${
              daysBetween(new Date(), new Date(lastDate)) === 0
                ? ''
                : daysBetween(new Date(), new Date(lastDate))
            } `}
            <strong>GÜN</strong>
          </span>
        </ExpirationDateWrapper>
      )}
      {ticketImage?.url && (
        <BottomRightImageWrapper backgroundImageUrl={ticketImage?.url} />
      )}
    </CardWrapper>
  );
};

export default CampainCard;
